import {Translate} from 'react-redux-i18n';
import {Redirect, Route, Switch} from 'react-router-dom';
import Header from './header';
import Tabs from './tabs';
import OrganisationProjectList from '../organisationProjectList';
import OrganisationUserList from '../organisationUserList';
import {useSubcontractorDetailsStore} from './SubcontractorDetailsStore';
import DocumentListArchived from '../documentListArchived';
import DocumentReminders from './documentReminders';
import PageNotFound from '../pageNotFound';
import NotDepositorMessage from './notDepositorMessage';
import Documents from './documents';
import {recordGAEvent} from '../../utils/analytics';

function SubcontractorDetailsView() {
  const {
    state: {
      subcontractor,
      documents,
      archives,
      interventions,
      users
    },
    dispatch
  } = useSubcontractorDetailsStore();

  // We need to wait for documents to load because the dossier country selector relies on documents to populate itself
  return (subcontractor.loading || documents.loading) ?
    <div className="loading-overlay"/> :
    <>
      <Header/>

      {!subcontractor.details.depositor && <NotDepositorMessage/>}

      <Tabs/>

      <div className="mb-5">
        <Switch>
          <Redirect
            from="/subcontractor/:subcontractorId"
            exact
            to="/subcontractor/:subcontractorId/documents"
          />
          <Route
            exact
            path="/subcontractor/:subcontractorId/documents"
            component={Documents}
          />
          <Route
            exact
            path="/subcontractor/:subcontractorId/archives"
            render={() => <>
              <DocumentListArchived
                documents={archives.list}
                error={archives.error}
                onDownloadDocumentFile={() => recordGAEvent('BUYER_DOCUMENT_HISTORY', 'Download historical supplier’s document')}
              />
              {archives.list.length === 0 &&
                <div
                  className="table-without-result"
                  style={{position: 'relative'}}
                >
                  {archives.loading && <div className="loading-overlay"/>}
                  <Translate value="document.noArchive"/>
                </div>
              }
            </>
            }
          />
          <Route
            exact
            path="/subcontractor/:subcontractorId/users"
            render={() => (
              <OrganisationUserList
                organisation={subcontractor.details}
                isSubcontractorView
                users={users.list}
                pageSize={users.pageSize}
                totalCount={users.totalCount}
                loading={users.loading}
                error={users.error}
                onRefresh={() => dispatch({type: 'FETCH_USERS'})}
              />
            )}
          />
          <Route
            exact
            path="/subcontractor/:subcontractorId/projects"
            render={() => (
              <OrganisationProjectList
                interventions={interventions.list}
                pageSize={interventions.pageSize}
                totalCount={interventions.totalCount}
                loading={interventions.loading}
                error={interventions.error}
                onPageChange={() => dispatch({type: 'FETCH_INTERVENTIONS'})}
                showDossierState
              />
            )}
          />
          <Route
            exact
            path="/subcontractor/:subcontractorId/document-reminders"
            component={DocumentReminders}
          />
          <Route component={PageNotFound}/>
        </Switch>
      </div>
    </>;
}

export default SubcontractorDetailsView;
